module.exports = __webpack_public_path__ + "img/cover2.eec9af6e.png";